import { ActivityRoutineProvider } from './activity-routine/activity-routine';
import { ApiProvider } from './api/api';
import { ConfigurationProvider } from './configuration/configuration';
import { DayEntryProvider } from './day-entry/day-entry';
import { EnumProvider } from './enum/enum';
import { ExerciseProvider } from './exercise/exercise';
import { FoodProvider } from './food/food';
import { FoodPlanProvider } from './food-plan/food-plan';
import { MealProvider } from './meal/meal';
import { SupplementProvider } from './supplement/supplement'
import { SupplementStackProvider } from './supplement/supplement-stack'
import { UserProvider } from './user/user';
import { UserMemoProvider } from './user/user-memo';
import { WorkoutProvider } from './workout/workout';

export {
  ActivityRoutineProvider,
  ApiProvider,
  ConfigurationProvider,
  DayEntryProvider,
  EnumProvider,
  ExerciseProvider,
  FoodProvider,
  FoodPlanProvider,
  MealProvider,
  SupplementProvider,
  SupplementStackProvider,
  UserMemoProvider,
  UserProvider,
  WorkoutProvider
};



// WEBPACK FOOTER //
// ./src/providers/providers.ts